<template>
    <!-- 8月加盟激励在线 -->
    <div class="ranking">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
            <img class="banner" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-08-12/${getTheme('bannerImg')}.png`" alt="banner">
            <!-- <img class="rule" @click="showRule = true" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-08-12/${getTheme('ruleImg')}.png`"> -->

            <div class="reward-box">
                <div class="reward" :class="[`baseHeight${currentJobTab}`]" :style="{ backgroundImage: `url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-08-12/${getTheme('rewardImg')}.png)` }">

                </div>

                <img v-if="!myInfo" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status1.png">
                <template v-else>
                    <img v-if="!isEnd && !isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status2.png">
                    <img v-if="!isEnd && isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status33.png">
                    <img v-if="isEnd && !isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status4.png">
                    <img v-if="isEnd && isAward" class="reward-status" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/award-status5.png">
                </template>

                <template v-if="myInfo">
                    <p class="reach" v-if="currentJobTab === '1' || currentJobTab === '2'">{{ getTheme('achieve') }}</p>
                    <p class="reach-amtYoy" :class="{ reachReach: isReach }" v-if="currentJobTab === '1' || currentJobTab === '2'">当前同期比进度为{{ amtYoy }}%{{ isReach ? '已达成' : '未达成' }}</p>
                    <div class="compare">
                        <div class="compare-data">
                            <p>{{ getTheme('leftText1') }}</p>
                            <p>{{ getTheme('leftText2') }}</p>
                            <p class="blue">{{ myData }}
                                <span v-if="currentJobTab !== '3'">W</span>
                            </p>
                        </div>
                        <img class="less" :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/${compare()}.png`">
                        <div class="compare-data">
                            <p>{{ getTheme('rightText1') }}</p>
                            <p>{{ getTheme('rightText2') }}</p>
                            <p class="red">{{ contrastData }}
                                <span v-if="currentJobTab !== '3'">W</span>
                            </p>
                        </div>
                    </div>
                    <p class="update-bottom" v-if="currentJobTab === '2' || currentJobTab === '4'">生美净消费指：生美自营护理+生美产品（不含联营项目）</p>
                    <p class="update-user" v-if="currentJobTab === '4'">参与排名岗位:主任&客户经理均可参加</p>
                    <p class="update-time">数据更新时间 {{ today }}0点</p>
                </template>
            </div>

            <div class="bg-color" :style="{ backgroundColor: getTheme('bgColor') }"></div>

            <div class="ranking-box">
                <div class="ranking-box-hd">
                    <div :class="{ on: isStore === 0 }" @click="onTabChange(0)">全部</div>
                    <div :class="{ on: isStore === 1 }" @click="onTabChange(1)">本店</div>
                </div>

                <div class="tabs-box">

                    <div class="job-tabs-wrapper">
                        <div class="job-tabs">
                            <div class="job-tab-item" :class="{ on: currentJobTab === it.dictValue }" v-for="it in jobTabs" :key="it.dictValue" @click="onJobTab(it.dictValue)">
                                {{ it.dictLabel }}
                            </div>
                        </div>
                    </div>

                    <div class="group-tabs" v-if="currentJobTab !== '4'">
                        <div class="group-tab-item" :style="{ backgroundColor: currentGroupTab === it ? getTheme('btnBgColor') : '#E6E6E6' }" :class="{ on: currentGroupTab === it }" v-for="it in groupTabs" :key="it" @click="onGroupTab(it)">
                            {{ it }}
                        </div>
                    </div>
                </div>

                <div class="ranking-list-box">
                    <div class="ranking-list-item-box" v-if="myInfo">
                        <RankingItem :status="currentJobTab" :item="myInfo" isMe :style="{ backgroundColor: getTheme('cardBgColor') }" />
                    </div>

                    <div class="ranking-list-item title">
                        <div class="ranking-num">排名</div>
                        <div class="ranking-name">{{ getTheme('title1') }}</div>
                        <div class="ranking-order" :class="{ counting: currentJobTab === '3' }">{{ getTheme('title2') }}</div>
                        <div class="ranking-bonus" v-if="currentJobTab === '1' || currentJobTab === '2'">同期比</div>
                    </div>

                    <RankingItem :status="currentJobTab" :statusTab="currentGroupTab" :item="it" :index="it.rnk" v-for="it in list" :key="it.uniqueId" />
                </div>
            </div>
        </van-list>


        <!-- 规则弹框 -->
        <van-popup v-model="showRule" round>
            <div class="popup-rule">
                <div class="popup-rule-hd">活动规则</div>
                <div class="popup-main">
                    <div class="title">一、工作内容</div>
                    <div class="describe">
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                    </div>

                    <div class="title">二、任职资格</div>
                    <div class="describe">
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                        <div>(1) XXXXXXXXXXXXXXXXX</div>
                    </div>
                </div>
            </div>
            <van-icon class="popup-close" name="close" size="40" color="#ffffff" @click="showRule = false" />
        </van-popup>

    </div>
</template>

<script>
    import request from '@/utils/request'
    import RankingItem from './rankingItem.vue'
    import { uniqueId, debounce } from 'lodash';
    import { getCookie } from '@/utils';
    import { Toast } from 'vant'

    export default {
        name: 'RankingList',
        components: {
            RankingItem
        },
        data() {
            return {
                showRule: false, // 是否显示规则弹窗
                jobTabs: [], // 职位分类标签列表
                currentJobTab: '1', // ['美疗师', '技术监理', '客户经理', '主任', '区经']
                groupTabs: [], // 分组标签列表
                currentGroupTab: '第1组', // 当前选中的分组
                loading: false, // 是否正在加载
                finished: false, // 是否加载完成
                list: [], // 排名列表数据
                isStore: 0, // 当前选中的tab
                page: 1, // 当前页码
                today: new Date().getMonth() + 1 + '月' + new Date().getDate() + '日', // 当前日期，格式为"月日"
                hour: new Date().getHours(), // 当前小时数
                error: false, // 是否发生错误
                myInfo: {}, // 当前用户的数据
                isAward: false, // 是否获奖
                isReach: false, // 是否达到目标
                isEnd: new Date().getTime() > new Date('2025-10-03 23:59:59').getTime(), // 活动是否已结束
                contrastData: 0, // 对比数据，用于与当前用户数据进行对比
                myData: 0,// 当前用户的数据，用于展示用户自身排名信息
                postId: '', // 员工id
                // 员工id列表, 分别对应['美疗师', '技术监理', '客户经理', '主任', '区经']
                postIdList: [['7'], ['4'], ['2', '42'], ['1'], ['11', '1472787652026765457', '1472787652026765732']],
                role: '', // 当前用户的角色
                amtYoy: ''
            }
        },
        mounted() {
            this.getjobTabs()
        },
        methods: {
            // 初始化数据，获取销售列表
            getDataList: debounce(async function (reset) {

                if (this.finished) return
                Toast.loading({
                    forbidClick: true,
                    duration: 0
                });
                try {
                    const params = {
                        groupNo: this.currentGroupTab,
                        isStore: this.isStore,
                        type: this.currentJobTab,
                        page: this.page
                    }
                    const { msg, data } = await request({
                        url: '/promotion/getList',
                        method: 'get',
                        params
                    })
                    if (msg !== 'success') {
                        throw new Error(msg)
                    }
                    Toast.clear();
                    let list = data[this.getTheme('list')]
                    this.myInfo = data[this.getTheme('info')]

                    list = list.map(it => {
                        it.uniqueId = uniqueId()
                        return it
                    })
                    // this.list直接赋值, 不置空, 防止页面高度丢失导致闪屏
                    if (this.page === 1) {
                        this.list = list
                        this.resetList = false
                    } else {
                        this.list = [...this.list, ...list]
                    }
                    this.isAward = data.isAward * 1
                    this.isReach = data.isReach * 1
                    this.amtYoy = data.amtYoy
                    this.contrastData = data.contrastData
                    this.myData = data.myData

                    this.page += 1
                    this.loading = false;

                    if (list.length < 10) {
                        this.finished = true;
                    }
                } catch (error) {
                    this.loading = false;
                    this.error = true;
                    this.$toast(error)
                    Toast.clear();
                }

            }, 500),
            // 获取职位分类标签
            async getjobTabs() {
                const { data } = await request({
                    url: '/dict/type/dictList',
                    method: 'get',
                    params: { dictType: 'jm_dep_list' }
                })
                this.jobTabs = data
                this.getGroupTab()
            },
            // 获取分组标签
            async getGroupTab() {
                const { data } = await request({
                    url: '/promotion/groupNo',
                    method: 'get',
                    params: { type: this.currentJobTab }
                })
                this.groupTabs = data && data.list && data.list.length > 0 ? data.list : []
                this.currentGroupTab = data && data.groupNo ? data.groupNo : data && data.list[0] // 默认选中
                this.getDataList()
            },
            onLoad() {
                this.getDataList()
            },
            // 切换职位分类标签
            onJobTab(value) {
                if (this.currentJobTab === value) return
                this.currentJobTab = value;
                this.page = 1
                this.finished = false
                this.error = false;
                this.isStore = 0

                this.getGroupTab()
            },
            // 切换分组标签
            onGroupTab(value) {
                if (this.currentGroupTab === value) return
                this.currentGroupTab = value;
                this.finished = false
                this.error = false;
                this.page = 1

                this.getDataList()

            },
            // 切换全部/本店标签
            onTabChange(value) {
                if (this.isStore === value) return
                if (this.currentJobTab !== '4') {
                    this.$toast('请切换至【个人生美销售额】排行榜查看本店数据')
                    return
                }
                this.isStore = value;
                this.finished = false
                this.error = false;
                this.page = 1

                this.getDataList()
            },
            compare() {
                return Number(this.myData) > Number(this.contrastData) ? 'more' : this.myData === this.contrastData ? 'equal' : 'less'
            },
            // 获取主题色和图片和文字
            getTheme(type) {
                if (this.jobTabs.length === 0) return
                const index = this.jobTabs.findIndex(it => it.dictValue === this.currentJobTab);
                const theme = {
                    bgColor: ['#F3DAA2', '#F3DAA2', '#F3DAA2', '#AB080B'],
                    btnBgColor: ['#B07626', '#B07626', '#B07626', '#B07626'],
                    cardBgColor: ['#FFF7E7', '#FFF7E7', '#FFF7E7', '#FFF7E7'],
                    bannerImg: ['bannerEquities', 'bannerConsumer', 'bannerMember', 'bannerPerson'],
                    rewardImg: ['travel', 'travel', 'travel2', 'prize'],
                    ruleImg: ['rule2', 'rule2', 'rule2', 'rule'],
                    leftText1: ['我的门店', '我的门店', '我的门店', '我的'],
                    leftText2: ['当前权益金总额', '当前生美净消费总额', '当前新会员纳新人数', '当前生美销售额'],
                    rightText1: ['第3名门店', '第3名门店', '第3名门店', '第20名'],
                    rightText2: ['当前权益金总额', '当前生美净消费总额', '当前新会员纳新人数', '当前生美销售额'],
                    updateTime: ['护理开单额数据更新时间', '非0护理客流数据更新时间', '护理销售额数据更新时间', '权益金、营业收入数据更新时间', '权益金、营业收入数据更新时间'],
                    // rewardText1: ['组内前20名', `组内前${this.getGroupBonus('rewardText1_1')}名`, '组内前15名', '根据3+4权益金贡献', '根据3+4权益金贡献'],
                    // rewardText2: [`瓜分<span class="red">${this.getGroupBonus('rewardText2_1')}元</span>奖金`, '奖励<span class="red">800元</span>现金', `获得<span class="red">${this.getGroupBonus('rewardText2_3')}元</span>现金`, `小组获奖人瓜分<span class="red">${this.getGroupBonus('rewardText2_4')}元</span>奖金池`, `小组获奖人瓜分<span class="red">${this.getGroupBonus('rewardText2_5')}元</span>奖金池`],
                    title1: ['门店', '门店', '门店', '员工'],
                    title2: ['累计权益金', '累计生美净消费', '新会员纳新人数（折算后） ', '生美销售额'],
                    title3: ['预计瓜分奖金', '预计获得奖金', '预计获得奖金', '预计瓜分奖金', '预计瓜分奖金'],
                    achieve: ['2025年周年庆期间累计权益金总额应≥同期105%', '2025年周年庆期间生美净消费总额应≥同期105%'],
                    list: ['storeSalekpiList', 'storeSalekpiList', 'storeNxList', 'empSaleList'],
                    info: ['storeSalekpi', 'storeSalekpi', 'storeNx', 'empSale']

                }
                return theme[type][index];
            },
            // 将二次套娃的单独拿出来, 减少代码触发判断的次数
            getThemeBonus(type) {
                if (this.groupTabs.length === 0 || this.jobTabs.length === 0) return 0
                const index = this.jobTabs.findIndex(it => it.dictValue === this.currentJobTab);
                const theme = {
                    rewardText1: ['组内前20名', `组内前${this.getGroupBonus('rewardText1_1')}名`, '组内前15名', '根据8+9权益金贡献', '根据8+9权益金贡献'],
                    rewardText2: [`瓜分<span class="red bold font30">${this.getGroupBonus('rewardText2_1')}元</span>/奖金`, '奖励<span class="red">600元</span>现金', `获得<span class="red">${this.getGroupBonus('rewardText2_3')}元</span>现金`, `小组获奖人瓜分<span class="red">${this.getGroupBonus('rewardText2_4')}元</span>奖金池`, `小组获奖人瓜分<span class="red">${this.getGroupBonus('rewardText2_5')}元</span>奖金池`],
                }
                return theme[type][index];
            },
            // 根据分组展示不同的数据
            getGroupBonus(type) {
                const index = this.groupTabs.findIndex(it => it === this.currentGroupTab)
                const theme = {
                    rewardText2_1: [15000, 12000, 8000, 8000, 8000],
                    rewardText1_1: [10, 10, 10, 8, 1],
                    rewardText2_3: [1600, 1400, 1200, 1000],
                    top16_30: [800, 600, 400, 200],
                    rewardText2_4: [12000, 30000, 15000, 8000],
                    rewardText2_5: [20000, 15000, 8000],
                }
                return theme[type][index]
            }
        }
    }
</script>

<style lang='less' scoped>
    .ranking {
        position: relative;
        height: 100%;
        font-size: 28px;
        overflow-y: scroll;
        color: #333333;
        background-color: #fff;

        .bold {
            font-weight: bolder;
        }

    }

    .banner {
        width: 100%;
        height: 464px;
    }

    .rule {
        position: absolute;
        width: 120px;
        top: 50px;
        right: 0;
    }

    .reward-box {
        position: relative;
        width: 100%;
        // height: 860px;
        margin-top: -94px;
        padding: 30px;
        text-align: center;
        background-color: #fff;
        border-radius: 40px;
        z-index: 9;

        .reward-status {
            width: 100%;
            margin-bottom: 30px;
        }

        .reach {
            font-size: 28px;
        }

        .reach-amtYoy {
            font-size: 28px;
            color: #D94335;
        }

        .reachReach {
            font-size: 28px;
            color: #0072FF;
        }

        .baseHeight4 {
            height: 695px;
        }
    }

    .reward {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        height: 376px;
        margin-bottom: 30px;
        // background-image: url('https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/bg.png');
        background-size: 100% 100%;

        &.left {
            padding-right: 30px;
            padding-left: 20px;

            .reward-data:nth-of-type(1) {
                flex: 1.7;
            }
        }

        .reward-data {
            flex: 1;
            text-align: center;

            >img {
                height: 150px;
            }
        }
    }

    .compare {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 30px 0;

        .less {
            width: 40px;
            height: 40px;
        }

        .compare-data {
            width: 45%;

            p {
                margin-bottom: 10px;
            }

            p:first-child {
                font-size: 36px;
            }

            p:nth-child(2) {
                font-size: 24px;
            }

            p:last-child {
                font-size: 46px;
                font-weight: 500;
            }
        }
    }

    .update-time {
        font-size: 24px;
        color: #999999;
    }

    .update-user {
        font-size: 28px;
        color: #333333;
    }

    .update-bottom {
        font-size: 18px;
        color: #333333;
    }

    .fs-32 {
        font-size: 32px;
    }

    .blue {
        color: #007AFF;
        font-weight: 500;
    }

    .ranking-box {
        overflow: hidden;
        background-color: #fff;
        border-radius: 40px 40px 0 0;
    }

    .ranking-box-hd {
        display: flex;

        >div {
            width: 50%;
            line-height: 100px;
            font-size: 36px;
            font-weight: 500;
            text-align: center;
            color: #999999;
            background-color: #F5F5F5;

            &.on {
                color: #333333;
                background-color: #ffffff;
            }
        }
    }

    .tabs-box {
        padding: 0 30px;
    }

    .job-tabs-wrapper {
        width: 100%;
        overflow-x: auto;
        scrollbar-width: none;
        /* 隐藏滚动条 Firefox */
        -ms-overflow-style: none;
        /* 隐藏滚动条 IE/Edge */

        &::-webkit-scrollbar {
            display: none;
            /* 隐藏滚动条 Chrome/Safari */
        }
    }

    .job-tabs {
        display: flex;
        align-items: center;
        min-width: max-content;
        /* 确保内容宽度超过容器时可滚动 */
        padding: 0px;

        /* 移除原来的 justify-content: space-around，避免标签分布不均 */
        justify-content: flex-start;
    }

    .job-tab-item {
        flex: 0 0 auto;
        /* 防止项目被压缩 */
        padding: 20px 15px;
        font-size: 30px;
        font-weight: 500;
        color: #999999;
        white-space: nowrap;
        /* 防止文字换行 */

        &.on {
            position: relative;
            color: #333333;
        }
    }

    .group-tabs {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
    }

    .group-tab-item {
        width: 120px;
        height: 40px;
        margin-right: 30px;
        line-height: 40px;
        text-align: center;
        font-size: 26px;
        color: #333333;
        background-color: #E6E6E6;
        border-radius: 20px;

        &.on {
            color: #ffffff;
            background-color: #AB080B;
        }
    }

    .ranking-list-box {
        border-top: 2px solid #eeeeee;
    }

    .ranking-list-item-box {
        padding: 0 20px;
    }

    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }
    }

    .ranking-num {
        width: 60px;
        margin-right: 40px;

        .color-red {
            color: #AB080B;
        }

        >img {
            width: 50px;
            height: 60px;
        }
    }

    .ranking-name {
        display: flex;
        align-items: center;
        width: 240px;

        >.img {
            width: 60px;
            height: 60px;
            margin-right: 10px;
        }

    }

    .ranking-order {
        width: 160px;
        text-align: center;
    }

    .counting {
        width: 230px;
    }

    .ranking-bonus {
        width: 180px;
        text-align: center;
    }



    .popup-rule {
        width: 650px;
        padding-bottom: 30px;
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
    }

    .popup-rule-hd {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 120px;
        font-size: 36px;
        font-weight: 500;
        background-image: linear-gradient(#CEDBF0, #ffffff);
    }

    .popup-main {
        height: 600px;
        overflow-y: scroll;

        >.title {
            padding: 20px 40px;
            font-size: 28px;
            font-weight: 500;
        }

        >.describe {
            padding: 0 60px;
            font-style: 24px;
            color: #66757F;
            line-height: 46px;
        }
    }

    .popup-close {
        position: absolute;
        left: 50%;
        bottom: -90px;
        transform: translate(-50%);
    }

    .bg-color {
        height: 90px;
        margin: -30px 0;
    }
</style>
<style lang="less">
    .ranking {
        .red {
            color: #D41D16;
        }

        .bold {
            font-weight: bold !important;
        }

        .font30 {
            font-size: 30px;
        }

        .van-popup {
            overflow-y: visible;
        }

        .van-image__error {
            background-color: #A1A1A1;
        }

        .van-list__finished-text,
        .van-list__loading,
        .van-list__error-text {
            margin-top: -2px;
            background-color: #fff;
        }
    }
</style>